"use client";

import { QueryClient, QueryClientProvider, MutationCache } from "@tanstack/react-query";
import { useState } from "react";
import { ThemeProvider } from "@/components/chrome/ThemeContext";
import { AuthProvider } from "@/lib/context/AuthContext";
import { AuthModalProvider } from "@/lib/context/AuthModalContext";
import { AuthModal } from "@/components/auth/AuthModal";
import { Toaster } from "@/components/ui/toaster";

export function Providers({ children }: { children: React.ReactNode }) {
  const [client] = useState(
    () =>
      new QueryClient({
        defaultOptions: {
          queries: {
            staleTime: 30_000,
            refetchOnWindowFocus: false,
            retry: 1,
          },
        },
        mutationCache: new MutationCache({
          onSuccess: (_data, _variables, _context, mutation) => {
            const invalidates = (mutation.meta as { invalidates?: readonly (readonly string[])[] } | undefined)?.invalidates;
            if (invalidates) {
              for (const key of invalidates) {
                client.invalidateQueries({ queryKey: key as string[] });
              }
            }
          },
        }),
      }),
  );

  return (
    <ThemeProvider>
      <AuthProvider>
        <AuthModalProvider>
          <QueryClientProvider client={client}>{children}</QueryClientProvider>
          <AuthModal />
          <Toaster />
        </AuthModalProvider>
      </AuthProvider>
    </ThemeProvider>
  );
}
